//This map stores the labels for the outcomes of any button action
// Could be further broken down into multiple maps for each button action type

import {
  actionButtonNavigationConfigType,
  actionButtonOutcomeLabelsConfigType,
  ActionButtonOutcomesType,
} from './action-button-navigation-config.type';
import { accountNavigationConfigMap } from './action-button-navigation/account-navigation';
import { beneficiaryNavigationConfigMap } from './action-button-navigation/beneficiary-navigation';
import { businessOnboardingNavigationConfigMap } from './action-button-navigation/business-onboarding-navigation';
import { cardManagementNavigationConfigMap } from './action-button-navigation/card-management-navigation';
import { documentNavigationConfigMap } from './action-button-navigation/document-action-navigation';
import { exchangeNavigationConfigMap } from './action-button-navigation/exchange-currency-navigation';
import { generalNavigationConfigMap } from './action-button-navigation/general-action-navigation';
import { onboardingNavigationConfigMap } from './action-button-navigation/onboarding-navigation';
import { paymentsNavigationConfigMap } from './action-button-navigation/payment-navigation';
import { profileNavigationConfigMap } from './action-button-navigation/profile-navigation';
import { savingsAccountNavigationConfigMap } from './action-button-navigation/saving-account-navigation';
import { transactionNavigationConfigMap } from './action-button-navigation/transactions-actions-navigation';
import { ButtonActionType } from './common.type';

// e.g; Payments, Profile, User Management, etc.
export const ActionButtonWidgetActionsOutcomesLabelsMap: Map<
  ButtonActionType,
  actionButtonOutcomeLabelsConfigType[]
> = new Map([
  [
    ButtonActionType.INITIATE_PAYMENT_SUMMARY,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success (Sufficient Balance)' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure (Insufficient Balance)' },
    ],
  ],
  [
    ButtonActionType.SUBMIT_PAYMENT,
    [
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Payment Processing' },
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Payment Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Payment Failure' },
    ],
  ],
  [
    ButtonActionType.DEACTIVATE_LEDGER_ACCOUNT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.SAVE_SPENDING_BUDGET,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.MARK_FAVORITE_BENEFICIARY,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.REMOVE_FAVORITE_BENEFICIARY,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.DELETE_DOCUMENT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Document Deleted Successfully' },
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Deletion in Progress' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failed to Delete Document' },
    ],
  ],
  [ButtonActionType.VIEW_DOCUMENT, [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Click' }]],
  [
    ButtonActionType.DOWNLOAD_DOCUMENT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Download Successful' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Download Failed' },
    ],
  ],
  [
    ButtonActionType.INIT_INTL_PAYMENT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Processing' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.INTL_TRANSFER_PRECHECK,
    [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' }],
  ],
  [
    ButtonActionType.CHECK_SMS_AUTH_STATUS_AND_REDIRECT,
    [
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Processing' },
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.PAYMENT_REQUEST_APPROVE,
    [
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Processing' },
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.PAYMENT_REQUEST_REJECT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.PAYMENT_APPROVER_MAKE_PAYMENT,
    [
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Processing' },
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.PAYMENT_REQUEST_PROCESSING,
    [
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Processing' },
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.BENEFICIARY_FORM_ADDRESS_PROCEED,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Beneficiary Account Details Complete' },
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Go to Beneficiary Bank Details' },
    ],
  ],
  [
    ButtonActionType.BENEFICIARY_FORM_BANK_PROCEED,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Beneficiary Account Details Complete' },
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Go to Beneficiary Address Details' },
    ],
  ],
  [
    ButtonActionType.BENEFICIARY_FORM_SUBMIT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Beneficiary Submit Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Beneficiary Submit Failure' },
    ],
  ],
  [
    ButtonActionType.WITHDRAW_FROM_SAVINGS_ACCOUNT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Withdrawal Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Withdrawal Failed' },
      { outcomeType: ActionButtonOutcomesType.ALTERNATE_1, label: 'Full Balance Withdrawal' },
    ],
  ],
  [
    ButtonActionType.ONBOARDING_SUBMIT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Onboarding Submit Success' },
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Onboarding Submit Pending' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Onboarding Submit Failure' },
      { outcomeType: ActionButtonOutcomesType.ALTERNATE_1, label: 'Onboarding Submit Alternate Failure' },
      {
        outcomeType: ActionButtonOutcomesType.PRODUCT_UNAVAILABLE,
        label: 'Onboarding Submit Product Unavailable',
      },
      {
        outcomeType: ActionButtonOutcomesType.ALTERNATE_2,
        label: 'Onboarding Submit OTP Expiry',
      },
      {
        outcomeType: ActionButtonOutcomesType.ALTERNATE_3,
        label: 'Onboarding Submit CoP Check Expiry',
      },
    ],
  ],
  [
    ButtonActionType.ONBOARDING_BANK_DETAILS_VERIFICATION,
    [
      {
        outcomeType: ActionButtonOutcomesType.SUCCESS,
        label: 'Onboarding Bank Details Verification Success',
      },
      {
        outcomeType: ActionButtonOutcomesType.FAILURE,
        label: 'Onboarding Bank Details Verification Failure',
      },
    ],
  ],
  [
    ButtonActionType.PISP_REVIEW,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Review Deposit' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Pick PISP Institution' },
      { outcomeType: ActionButtonOutcomesType.ALTERNATE_1, label: 'Institution Not Supported' },
    ],
  ],
  [
    ButtonActionType.PISP_DEPOSIT,
    [
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Deposit Pending' },
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Deposit Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Deposit Failure' },
      { outcomeType: ActionButtonOutcomesType.ALTERNATE_1, label: 'Initiating (Custom Payment Page)' },
      {
        outcomeType: ActionButtonOutcomesType.ALTERNATE_2,
        label: 'Deposit started - sent to banking app on MOBILE (Custom Payment Page)',
      },
    ],
  ],
  [
    ButtonActionType.BENEFICIARY_FORM_COP,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'COP Match' },
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'COP Close Match' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'COP No Match' },
      { outcomeType: ActionButtonOutcomesType.INCOMPLETE, label: 'COP Secondary Identifier Required' },
      { outcomeType: ActionButtonOutcomesType.ALTERNATE_1, label: 'No COP Beneficiary Add Success' },
      { outcomeType: ActionButtonOutcomesType.ALTERNATE_2, label: 'No COP Beneficiary Add Failure' },
    ],
  ],
  [
    ButtonActionType.ADD_BENEFICIARY,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Beneficiary Submit Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Beneficiary Submit Failure' },
    ],
  ],
  [
    ButtonActionType.USE_SUGGESTED_NAME_COP,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Beneficiary Submit Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Beneficiary Submit Failure' },
    ],
  ],
  [
    ButtonActionType.INITIATE_SAVINGS_INTERNAL_TRANSFER,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.SUBMIT_USER_PROFILE_UPDATE,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.VERIFICATION_EDIT_INFORMATION,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.OPEN_NEW_SAVINGS_ACCOUNT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Approved' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Rejected' },
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Awaiting Approval' },
      { outcomeType: ActionButtonOutcomesType.ALTERNATE_1, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.REVIEW_ACCOUNT_REQUESTS,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'One account request found' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'No Open Requests Found' },
      { outcomeType: ActionButtonOutcomesType.ALTERNATE_1, label: 'More than one account request found' },
    ],
  ],
  [
    ButtonActionType.CLEAR_FORM_STATE_AND_REDIRECT,
    [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Clearing form state' }],
  ],
  [
    ButtonActionType.UPDATE_MARKETING_PREFERENCES,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.CLOSE_SAVINGS_ACCOUNT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.MATURITY_DECISION_RENEW,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.MATURITY_DECISION_WITHDRAW,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.MATURITY_DECISION_PARTIAL_REINVEST,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.EXCHANGE_ACCEPT_QUOTE,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.CANCEL_SCHEDULED_PAYMENT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Cancel scheduled payment complete' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Cancel scheduled payment fail' },
    ],
  ],
  [
    ButtonActionType.CANCEL_PENDING_WITHDRAWAL,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.FEEDBACK_COUNTER,
    [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Feedback counter navigation' }],
  ],
  [
    ButtonActionType.EDIT_BENEFICIARY_UNIFIED,
    [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' }],
  ],

  [
    ButtonActionType.SECURE_CVV_DETAILS,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],

  [
    ButtonActionType.CANCEL_CARD,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],

  [
    ButtonActionType.SET_CARD_NAME,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],

  [
    ButtonActionType.SHOW_PIN,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],

  [
    ButtonActionType.REFRESH_CARDS_AND_REDIRECT,
    [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' }],
  ],

  [
    ButtonActionType.GET_SENSITIVE_CARD_DETAILS,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.SUBMIT_PROFILE_CHANGES_IN_PROFILE_ZONE,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.CLEAR_FORM_STATE_AND_REDIRECT_TO_EDIT_PROFILE,
    [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' }],
  ],
  [
    ButtonActionType.TOGGLE_BIOMETRIC_AUTHENTICATION,
    [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' }],
  ],
  [
    ButtonActionType.UPDATE_ORGANISATION,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.REMOVE_BENEFICIARY,
    [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' }],
  ],
  [
    ButtonActionType.START_A_NEW_SUPPORT_CHAT,
    [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' }],
  ],
  [
    ButtonActionType.CHECK_PAYEE_FOR_NOMINATED_BANK_ACCOUNT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.UPDATE_NOMINATED_BANK_ACCOUNT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.INVITE_JOINT_ACCOUNT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.ACCEPT_JOINT_ACCOUNT_INVITATION,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
      { outcomeType: ActionButtonOutcomesType.ALTERNATE_1, label: 'New User' },
    ],
  ],
  [
    ButtonActionType.DECLINE_JOINT_ACCOUNT_INVITATION,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.ADD_CARD,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.ACTIVATE_CARD,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.SAVE_TRANSACTION_NOTE,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Failure' },
    ],
  ],
  [
    ButtonActionType.EDIT_TRANSACTION_NOTE,
    [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Storing the note in state' }],
  ],
  [ButtonActionType.ADD_DIRECTOR, [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' }]],
  [ButtonActionType.SAVE_DIRECTOR, [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' }]],
  [ButtonActionType.REMOVE_DIRECTOR, [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' }]],
  [
    ButtonActionType.SAVE_PRIMARY_DIRECTOR_INFO,
    [{ outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Success' }],
  ],
  [
    ButtonActionType.BUSINESS_ONBOARDING_SUBMIT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Business Onboarding Submit Success' },
      { outcomeType: ActionButtonOutcomesType.PROCESSING, label: 'Business Onboarding Submit Pending' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Business Onboarding Submit Failure' },
      {
        outcomeType: ActionButtonOutcomesType.ALTERNATE_1,
        label: 'Business Onboarding Submit Alternate Failure',
      },
      {
        outcomeType: ActionButtonOutcomesType.ALTERNATE_2,
        label: 'Business Onboarding Submit OTP Expiry',
      },
      {
        outcomeType: ActionButtonOutcomesType.ALTERNATE_3,
        label: 'Business Onboarding Submit Password Not Found',
      },
    ],
  ],
  [
    ButtonActionType.PISP_CANCEL_RECURRING_PAYMENT,
    [
      { outcomeType: ActionButtonOutcomesType.SUCCESS, label: 'Cancel recurring payment complete' },
      { outcomeType: ActionButtonOutcomesType.FAILURE, label: 'Cancel recurring payment fail' },
    ],
  ],
]);

// This map stores the default navigation config for any button action
// Could be further broken down into multiple maps for each button action category
// e.g; Payments, Profile, User Management, etc.
export const ActionButtonWidgetActionsOutcomesNavigationConfigMap: Map<
  ButtonActionType,
  actionButtonNavigationConfigType
> = new Map([
  ...accountNavigationConfigMap,
  ...beneficiaryNavigationConfigMap,
  ...documentNavigationConfigMap,
  ...exchangeNavigationConfigMap,
  ...generalNavigationConfigMap,
  ...onboardingNavigationConfigMap,
  ...paymentsNavigationConfigMap,
  ...profileNavigationConfigMap,
  ...savingsAccountNavigationConfigMap,
  ...cardManagementNavigationConfigMap,
  ...transactionNavigationConfigMap,
  ...businessOnboardingNavigationConfigMap,
]);
